import type { PermissionRecord } from "@/types/permissions";
import { hasPermission } from "@/utils/permission-utils";

/** Super admin with an active impersonated tenant (tenant-scoped session). */
export function isSuperAdminWithTenantContext(): boolean {
  return (
    localStorage.getItem("isSuperAdmin") === "1" &&
    Boolean(localStorage.getItem("impersonatedTenantId"))
  );
}

/**
 * Whether the session has a tenant context for tenant-scoped admin features.
 * Regular admins always do; super admins only after selecting a tenant.
 */
export function hasTenantAdminContext(): boolean {
  if (localStorage.getItem("isSuperAdmin") === "1") {
    return Boolean(localStorage.getItem("impersonatedTenantId"));
  }
  return true;
}

export function canViewTenantApiKeys(permissions: PermissionRecord | null | undefined): boolean {
  if (!hasTenantAdminContext()) {
    return false;
  }
  if (isSuperAdminWithTenantContext()) {
    return true;
  }
  return hasPermission(permissions, "tenantApiKeys.view");
}

export function canCreateTenantApiKeys(permissions: PermissionRecord | null | undefined): boolean {
  if (!hasTenantAdminContext()) {
    return false;
  }
  if (isSuperAdminWithTenantContext()) {
    return true;
  }
  return hasPermission(permissions, "tenantApiKeys.create");
}

export function canEditTenantApiKeys(permissions: PermissionRecord | null | undefined): boolean {
  if (!hasTenantAdminContext()) {
    return false;
  }
  if (isSuperAdminWithTenantContext()) {
    return true;
  }
  return hasPermission(permissions, "tenantApiKeys.edit");
}

export function canDeleteTenantApiKeys(permissions: PermissionRecord | null | undefined): boolean {
  if (!hasTenantAdminContext()) {
    return false;
  }
  if (isSuperAdminWithTenantContext()) {
    return true;
  }
  return hasPermission(permissions, "tenantApiKeys.delete");
}
